export default "__VITE_ASSET__CG80D_T4__"